// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixData from 'wix-data';
// import wixLocation from 'wix-location';

$w.onReady(async function () {
    //TODO: write your page related code here...
    let post = await $w('#post1').getPost()
    let term = post.title
    let relatedTerms = await wixData.query('Terms').contains("title", term.trim()).find();

    if (relatedTerms && relatedTerms.totalCount > 0) {
        let relatedBlogs = await wixData.queryReferenced('Terms', relatedTerms.items[0]._id, 'blogPost');
        let relatedArr = relatedBlogs.items;
        let blogDetails1 = await wixData.query('BlogPosts').contains('itemTitle', relatedArr[0].itemTitle).find()
        let blogDetails2 = await wixData.query('BlogPosts').contains('itemTitle', relatedArr[1].itemTitle).find()
        let blogDetails3 = await wixData.query('BlogPosts').contains('itemTitle', relatedArr[2].itemTitle).find()
        $w('#sourceTitle1').text = relatedArr[0].type
        $w('#relatedBlog1').text = blogDetails1.items[0].itemTitle
        $w('#relatedBlog1').onClick(() => { $w('#html1').postMessage(relatedArr[0].url) })
        $w('#link1').link = relatedArr[0].url

        $w('#sourceTitle2').text = relatedArr[1].type
        $w('#relatedBlog2').text = blogDetails2.items[0].itemTitle
        $w('#relatedBlog2').onClick(() => { $w('#html1').postMessage(relatedArr[1].url) })
        $w('#link2').link = relatedArr[1].url

        $w('#sourceTitle3').text = relatedArr[2].type
        $w('#relatedBlog3').text = blogDetails3.items[0].itemTitle
        $w('#relatedBlog3').onClick(() => { $w('#html1').postMessage(relatedArr[2].url) })
        $w('#link3').link = relatedArr[2].url

        let relatedLinks = await wixData.queryReferenced('Terms', relatedTerms.items[0]._id, 'relatedTerms')

        let relatedLinksArr = relatedLinks.items

        $w('#relatedLink1').text = relatedLinksArr[0].title
        $w('#relatedLink1').onClick(() => { $w('#html1').postMessage(relatedLinksArr[0].link) })

        $w('#iconButton3').link = relatedLinksArr[0].link

        $w('#relatedLink2').text = relatedLinksArr[1].title
        $w('#relatedLink2').onClick(() => { $w('#html1').postMessage(relatedLinksArr[1].link) })

        $w('#iconButton2').link = relatedLinksArr[1].link
    }

});